export default __webpack_public_path__ + "static/970-61a90749bdac7d5da92dac85c667b7e3.gif";